import {UserModuleDb} from '@cp/model';
import {useCallback} from 'react';
import updateUserDoc from '../../api/user/updateUserDoc';
import getUserDoc from '../../api/user/getUserDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useRemoveSelectedModules() {
  const removeSelectedModulesFn = useCallback(async (moduleId: string): Promise<void> => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    const user = await getUserDoc(uid);
    const current: UserModuleDb[] = (user?.selectedModules ?? []).map((m) => ({moduleId: m.moduleId}));
    const next = current.filter((m) => m.moduleId !== moduleId);
    await updateUserDoc(uid, {selectedModules: next});
  }, []);

  const {loading, error, refetch} = useFunctionRun(removeSelectedModulesFn, {
    skipLoadOnMount: true,
  });

  return {
    removeSelectedModules: refetch,
    loading,
    error,
  };
}
